module.exports = "https://qp-assets.quero.com/assets/images/credit-card-brands/visa-nobg.svg?45330dbec96720aca392dafc54104508";